var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"mb-0"},[_c('v-col',[_c('h1',[_vm._v("Предыдущие обращения")])])],1),_c('patient-header'),_c('calls-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }